import { Uuid } from "./uuid";
import { NaiveDateTime } from "./datetime";
import { Shared, ShareSource } from "./shared";

export interface ExerciseMaterial {
    id: string;
    optional?: boolean;
    or?: string | null;
    params?: { [key: string]: any } | null;
}

export interface VideoExerciseVariant {
    title: { [key: string]: string };
    builtin_video_type: "variant" | "conditional";
    condition?: { [key: string]: boolean } | null;
    material: ExerciseMaterial[];
    video: { [key: string]: string };
    tools: string[];
    subtitles: { [key: string]: string };
}

export default interface VideoExercise {
    id: string;
    title: { [key: string]: string };
    is_new: boolean;
    group: string[];
    origin: string;
    deprecated: boolean;
    material: ExerciseMaterial[];
    description: { [key: string]: string };
    instructions: { [key: string]: string };
    provider_name: string;
    provider_clinic_id: Uuid | null;
    default: VideoExerciseVariant;
    variants: { [key: string]: VideoExerciseVariant };
    shared: Shared | null;
    share_source: ShareSource | null;
}

export interface ClinicVideoExercise {
    id: Uuid;
    created: NaiveDateTime;
    updated: NaiveDateTime;
    clinic_id: Uuid;
    title: string;
    description: string;
    video: string;
    instructions: string;
    exercise_group: string;
    variant: string
    variant_group: Uuid;
    tools: string[];
    shared: Shared | null;
    share_source: ShareSource | null;
}

export function get_video_url(
    video: string | { [key: string]: string } | null | undefined,
    language: string,
): string | null {
    let url: unknown;
    if (typeof video === "string") {
        url = video;
    } else if (video && typeof video === "object") {
        url = video[language] ?? video.en;
    }

    if (typeof url !== "string") {
        return null;
    }

    return url.trim() || null;
}

export function clinic_to_builtin(exercise: ClinicVideoExercise): VideoExercise {
    let default_variant: VideoExerciseVariant = {
        title: {},
        builtin_video_type: "variant",
        condition: null,
        tools: [],
        video: { "en": exercise.video },
        subtitles: {},
        material: [],
    };

    let builtin: VideoExercise = {
        id: exercise.id,
        origin: "clinic",
        deprecated: false,
        title: { "en": exercise.title },
        group: [exercise.exercise_group],
        description: { "en" : exercise.description },
        instructions: { "en" : exercise.instructions },
        default: default_variant,
        variants: {},
        is_new: false,
        provider_name: "",
        provider_clinic_id: null,
        material: [],
        shared: exercise.shared,
        share_source: exercise.share_source
    };

    return builtin;
}
